import { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation, withTranslation } from "react-i18next";
import { Outlet } from "react-router";

import Loader from "@components/shared/Loader/Loader";
import Tabs from "@components/shared/Tabs/Tabs";
import { CONSTANTS } from "@constants/index";
import { ResponseDataUserInfo } from "@models/components/user.model";
import handleResponse from "@services/apiConfig/api.response.service";
import API_SERVICES from "@services/index";

export const UserInfoComponent = () => {
  const { t } = useTranslation();

  const [data, setData] = useState<ResponseDataUserInfo | null>(null);

  const [isFetching, setIsFetching] = useState(false);

  const formattedDate = data?.profile?.registrationDate
    ? moment(data?.profile?.registrationDate).format(
        CONSTANTS.DATE_FORMATS.DAY_MONTH_YEAR_FORMAT
      )
    : "";

  const tabList = [
    {
      label: t("profileInfo"),
      name: "Info",
      route: "/user/info",
    },
    {
      label: t("reservations"),
      name: "Reservations",
      route: "/user/reservations",
    },
    // {
    //   name: "Member",
    //   label: t("member"),
    //   route: "/user/member",
    // },
  ];

  const userTitle = data?.profile?.firstName
    ? `${data.profile.firstName} ${data?.profile?.lastName || ""}`
    : data?.profile?.companyName || "";

  useEffect(() => {
    getUserProfile();
  }, []);

  const getUserProfile = async () => {
    setIsFetching(true);
    const data = await API_SERVICES.USER.GET_USER_PROFILE();
    const responseData = handleResponse(data);
    if (responseData?.ok) {
      setData(responseData.data);
      setIsFetching(false);
    } else setIsFetching(false);
  };

  return (
    <>
      {isFetching && <Loader isLoading={true} />}
      <div className="container-fluid px-0" data-testid="user-profile-title">
        <div className="fg-page-title-block-wrap">
          <div className="container">
            <div className="fg-page-title-block">
              <h3>{t("userProfile.userProfile")}</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="fg-manager-title-card">
              <i className="fa-solid fa-user-tie"></i>
              <div className="fg-manager-title-card-content">
                <h5 className="fg-manager-title" data-testid="user-title">
                  {userTitle}
                </h5>
                <p data-testid="user-registered-since">
                  {t("userProfile.registeredSince")}: {formattedDate}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fg-tab-wrap" data-testid="user-profile-tabs">
        <Tabs labels={tabList} />
        <div className="tab-content" id="pills-tabContent">
          <Outlet context={[data, getUserProfile]} />
        </div>
      </div>
    </>
  );
};

const UserInfoPage = withTranslation()(UserInfoComponent);

export default UserInfoPage;
